import { render, staticRenderFns } from "./ProductLanding.vue?vue&type=template&id=b1814b98&"
import script from "./ProductLanding.vue?vue&type=script&lang=js&"
export * from "./ProductLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports